<script lang="ts">
  import {modal} from '../stores/modal'
  import Login from '../authentication/Login.svelte'
  import Register from '../authentication/Register.svelte'
  import {user} from '../stores/user'
  import {changeLocale, lang, locales, t, urlWithLocaleSubdomain} from '../i18n'
  import DropdownWrapper from './DropdownWrapper.svelte'
  import {Link, listen as onPageChange, navigate} from 'svelte5-router'
  import api from '../api/api'
  import {sidebarOpened} from '../../src/stores/sidebar'
  import {onMount} from 'svelte'
  import {fade, slide} from 'svelte/transition'

  onMount(() => {
    onPageChange(() => {
      $sidebarOpened = false
    })
  })

  async function logout(e: Event) {
    e.preventDefault()

    await api.delete('/logout')
    navigate('/')
    $user = undefined
  }

  function openLogin(e: Event) {
    e.preventDefault()
    modal.show(Login)
  }

  function openRegister(e: Event) {
    e.preventDefault()
    modal.show(Register)
  }

  function onChangeLocale(event: Event, locale: { code: string }) {
    event.preventDefault()
    changeLocale(locale.code)
  }

  function onOutsideClick() {
    $sidebarOpened = false
  }

  function onEscape(e: KeyboardEvent) {
    if (!$sidebarOpened) return
    if (e.key === 'Escape') $sidebarOpened = false
  }
</script>

<svelte:window onkeydown={onEscape}/>

{#if $sidebarOpened}
  <div class="modal-backdrop" onclick={onOutsideClick} transition:fade></div>
{/if}

<div class="ui vertical inverted sidebar menu left animating {$sidebarOpened ? 'uncover visible' : ''}"
     transition:slide>
  {#if $user}

    <DropdownWrapper class="ui link item" let:show>
      <div class="sidebar-user-menu">
        <div class="user-pic">
          <img src={$user.avatar_big_thumgb} alt="User Avatar"/>
        </div>
        <i class="dropdown icon icon-p-drop-arrow"></i>
      </div>

      {#if show}
        <div class="sidebar-user-drop menu" transition:slide>
          <Link class="item" to="/settings">{t.topbar.account_settings}</Link>
          <Link class="item" to="/favorite">{t.topbar.favorite_poems}</Link>
          <Link class="item" to="/my-poems">{t.topbar.my_poems}</Link>
          <Link class="item" to="/my-collections">{t.topbar.my_collections}</Link>
          <Link class="item" to="/statistics">{t.topbar.my_statistics}</Link>
          <a class="item" href="#" onclick={logout}>
            {t.topbar.logout}
          </a>
        </div>
      {/if}
    </DropdownWrapper>

    <Link class="item" to="/poems/new">{t.topbar.add_poem}</Link>
  {/if}

  {#if !$user}
    <a class="item" onclick={openLogin}>{t.topbar.login}</a>
    <a class="item" onclick={openRegister}>{t.topbar.register}</a>
  {/if}

  <Link class="item" to="/">{t.topbar.home}</Link>
  <Link class="item" to="/explore">{t.topbar.explore}</Link>
  <Link class="item" to="/poets">{t.topbar.classics}</Link>
  {#if $user}
    <Link class="item" to={`/authors/${$user.handle}`}>{t.topbar.my_page}</Link>
  {/if}
  <Link class="item" to="/collections">{t.topbar.collections}</Link>

  <DropdownWrapper let:show class="ui link item">
    <div class="text">
      {t.locales[lang ?? '']}
    </div>

    {#if show}
      <div class="menu" transition:slide>
        {#each locales as localeItem}
          <a class="item" href={urlWithLocaleSubdomain(localeItem.code)} onclick={(e) => onChangeLocale(e, localeItem)}>
            {t.locales[localeItem.code]}
          </a>
        {/each}
      </div>
    {/if}
  </DropdownWrapper>
</div>

<style>
  .modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.5);
    z-index: 50;
  }

  .sidebar.menu {
    z-index: 51;
  }
</style>